var React = require('react');

function At (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#fff","d":"M0 160h640v160H0z","key":0}),React.createElement("path",{"fill":"#c8102e","d":"M0 0h640v160H0zm0 320h640v160H0z","key":1})]);
}

At.defaultProps = {"id":"flag-icons-at","viewBox":"0 0 640 480"};

module.exports = At;

At.default = At;
